"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Button = require("../button/Button");
const LoadingButton = _ref => {
  let {
    isLoading,
    spinner,
    ...props
  } = _ref;
  const StyledButton = (0, _styled.default)(_Button.Button)(_ref2 => {
    let {
      theme,
      isLoading: loading
    } = _ref2;
    return {
      backgroundColor: loading ? theme === null || theme === void 0 ? void 0 : theme.colors.loading : theme === null || theme === void 0 ? void 0 : theme.colors.primary,
      width: '100%',
      '&:hover': {
        backgroundColor: loading ? `${theme === null || theme === void 0 ? void 0 : theme.colors.loading} !important` : theme === null || theme === void 0 ? void 0 : theme.colors.primary
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement(StyledButton, Object.assign({
    isLoading: isLoading
  }, props, {
    type: "submit"
  }), isLoading && spinner, props.children);
};
var _default = exports.default = LoadingButton;